// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore, collection } from "firebase/firestore";
import { getAuth, signInAnonymously, onAuthStateChanged } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

const missingFirebaseConfigKeys = Object.entries(firebaseConfig)
  .filter(([, value]) => !value)
  .map(([key]) => key);

if (missingFirebaseConfigKeys.length > 0) {
  throw new Error(`Missing Firebase config: ${missingFirebaseConfigKeys.join(', ')}`);
}

// Initialize Firebase with offline persistence disabled
const app = initializeApp(firebaseConfig);

// Initialize Firestore with settings to prevent connection issues
const db = getFirestore(app);
const auth = getAuth(app);

// Ensure every session has a Firebase Auth handle so reads against the
// aggregate collections (feedbackDaily, feedbackStats) pass the rules
// gate `signedIn()`. Admin users sign in via Google/Email later — the
// anonymous session is upgraded automatically by signInWithEmailAndPassword.
//
// Why: the homepage Dashboard mounts without an AdminGate (public surface
// for ops visibility) but the firestore.rules now require an auth handle
// to read aggregates. Without this, an unauthenticated visitor sees an
// empty dashboard + console permission-denied. Anonymous auth gives
// Firebase a per-client handle for proper rate limiting without exposing
// site-level analytics to scrapers with the raw Firestore SDK config.
onAuthStateChanged(auth, (user) => {
  if (!user) {
    signInAnonymously(auth).catch((err) => {
      // Non-fatal: AdminGate-protected routes still show the sign-in
      // prompt. Public dashboard simply gets permission-denied on
      // aggregate reads.
      // eslint-disable-next-line no-console
      console.warn('[firebase] anonymous sign-in failed:', err?.code ?? err);
    });
  }
});

// Collection references
const feedbackCollection = collection(db, "feedback_collection");

// ---------------------------------------------------------------------------
// IxoraOne secondary app — used only for employee ID login.
// Config is the same as apps/dashboards/ixoraone-dashboard/src/lib/firebase.ts.
// ---------------------------------------------------------------------------
const ixoraoneConfig = {
  apiKey: import.meta.env.VITE_IXORAONE_API_KEY || 'AIzaSyBNgXamOIN4b6jWRKFfSs6PJjPEk91AzIU',
  authDomain: import.meta.env.VITE_IXORAONE_AUTH_DOMAIN || 'ixora-one.firebaseapp.com',
  projectId: import.meta.env.VITE_IXORAONE_PROJECT_ID || 'ixora-one',
  storageBucket: import.meta.env.VITE_IXORAONE_STORAGE_BUCKET || 'ixora-one.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_IXORAONE_MESSAGING_SENDER_ID || '159838767299',
  appId: import.meta.env.VITE_IXORAONE_APP_ID || '1:159838767299:web:dde59f36e9e8069e057a76',
};
const ixoraoneApp = initializeApp(ixoraoneConfig, 'ixoraone');
export const ixoraoneAuth = getAuth(ixoraoneApp);
export const ixoraoneDb = getFirestore(ixoraoneApp);

export { auth, db, feedbackCollection };